export const normalizeVector = (p) => ({
    x: p.x === 0 ? 0 : p.x / Math.abs(p.x),
    y: p.y === 0 ? 0 : p.y / Math.abs(p.y),
});
